



































































import { Component, Vue } from 'vue-property-decorator'
import { Meta } from '@sophosoft/vue-meta-decorator'

import IPhone from '@/components/icons/IPhone.vue'
import IEnvelope from '@/components/icons/IEnvelope.vue'
import {namespace} from "vuex-class"
import {checkContour} from "@/helpers/checkContour";

const roistat = namespace('roistat')
const profile = namespace("profile")

@Component({
  name: 'v-tech-support',

  components: {
    'i-phone': IPhone,
    'i-envelope': IEnvelope
  }
})
export default class TechSupport extends Vue {
  @roistat.Action('sendEvent') protected sendEvent:any
  @profile.State("userCompany") protected userCompany: any
  @Meta
  getMetaInfo() {
    return {
      title: 'Leadfrog - ' + this.$t('support.title')
    }
  }

  isDemo:boolean = false

  mounted() {
    let response = checkContour('getCountour', window.location.href)
    this.isDemo = response == 'demo'
  }

  isDemoContent(item:any) {
    return this.isDemo && item.icon == 'i-phone' ? '+49(0) 341 92 881 175' : item.content
  }

  isDemoLink(item:any) {
    return this.isDemo && item.icon == 'i-phone' ? 'tel:+49034192881175' : item.link
  }

  clickItem(item:any) {
    let params = [
      {
        "name": "“Техподдержка”: Переход " + (item.content == '+7 (800) 302-11-34' ? "в звонок 8-800" : 
                                              item.content == '+7 (969) 282-97-28' ? "в звонок 8-969" : 
                                              item.content == 'support@leadfrog.pro' ? "по адресу электронной почты" : ""),
        "data": {
          "company": this.userCompany.title
        }
      }
    ]
    this.sendEvent(params)
  }

  sendEventToRoistat() {
    let params = [
      {
        "name": "“Техподдержка”: Действие “Раскрыть ответ на вопрос”",
        "data": {
          "company": this.userCompany.title
        }
      }
    ]
    this.sendEvent(params)
  }
}
